<div class="tw-w-full tw-h-full tw-block tw-border-spacing-0 tw-overflow-hidden ">
    <div class="tw-flex tw-h-full tw-flex-col tw-flex-nowrap">
        <div class="tw-w-full tw-flex-initial">
            <toolbar class="tw-capitalize" (onAction)="back()" [bg]='"#000"'></toolbar>
        </div>
        <div class="tw-w-full tw-flex tw-items-center tw-justify-center tw-flex-wrap tw-flex-auto tw-overflow-x-hidden tw-overflow-y-auto tw-bg-black">
            <video class="tw-w-full" [src]="src" controls="controls" autoplay="autoplay" loop="loop" disablepictureinpicture="disablepictureinpicture" controlslist="nodownload nofullscreen noremoteplayback" playsinline="playsinline"></video>
        </div>
    </div>
</div>